// apps-kb-scroll.js - Scroll zone hover and activation

import state from './apps-state.js';
import * as nav from './apps-navigation.js';
import * as render from './apps-render.js';
import { keyboardState } from './apps-kb-state.js';
import * as helpers from './apps-kb-helpers.js';
import * as cursor from './apps-kb-cursor.js';
import * as navLogic from './apps-kb-navigation-logic.js';

export function showScrollZoneHover(side) {
    hideScrollZoneHover();
    
    const isFolder = !!state.openFolder;
    const leftZone = isFolder ? 
        document.getElementById('folderScrollZoneLeft') : 
        document.getElementById('scrollZoneLeft');
    const rightZone = isFolder ? 
        document.getElementById('folderScrollZoneRight') : 
        document.getElementById('scrollZoneRight');
    
    if (side === 'left' && leftZone) {
        leftZone.classList.add('keyboard-hover');
        keyboardState.scrollZoneHover = 'left';
    } else if (side === 'right' && rightZone) {
        rightZone.classList.add('keyboard-hover');
        keyboardState.scrollZoneHover = 'right';
    }
}

export function hideScrollZoneHover() {
    console.log('hideScrollZoneHover called');
    const zones = document.querySelectorAll('.scroll-zone');
    console.log('Found zones:', zones.length);
    zones.forEach(zone => {
        console.log('Removing classes from zone:', zone.id, 'has active:', zone.classList.contains('active'));
        zone.classList.remove('keyboard-hover');
        // Don't remove 'active' class - it should stay on during move mode
        // Only remove it when explicitly exiting move mode or transitioning to mouse
    });
    keyboardState.scrollZoneHover = null;
}

export function deactivateScrollZones() {
    // Fully deactivate scroll zones (removes both hover and active states)
    const zones = document.querySelectorAll('.scroll-zone');
    zones.forEach(zone => {
        zone.classList.remove('keyboard-hover');
        zone.classList.remove('active');
    });
    keyboardState.scrollZoneHover = null;
}

export function activateScrollZone(updateDragIndicators) {
    if (!keyboardState.scrollZoneHover) return;
    
    const isFolder = !!state.openFolder;
    const inMoveMode = keyboardState.moveMode.active;
    
    if (keyboardState.scrollZoneHover === 'left') {
        const currentScreen = helpers.getCurrentScreen();
        
        if (inMoveMode && currentScreen === 0) {
            // Only create temporary screen if one doesn't already exist
            if (!state.temporaryScreenSide || state.temporaryScreenSide !== 'left') {
                if (isFolder) {
                    nav.createTemporaryFolderScreenToLeft();
                } else {
                    nav.createTemporaryScreenToLeft();
                }
            } else {
                // Temporary screen already exists, just navigate to it
                nav.goToFolderScreen(0); // Temporary left screen is always at index 0
                nav.goToScreen(0);
            }
            
            setTimeout(() => {
                hideScrollZoneHover();
                const layout = helpers.getLayout();
                const maxFile = layout.leaves * 4 - 1;
                const icons = helpers.getCurrentIcons();
                const draggedIcon = keyboardState.moveMode.draggedIcon;
                const currentScreen = helpers.getCurrentScreenForRegions();
                
                // Check if MAX+0.5 is valid
                const isAppendValid = navLogic.isValidInsertPosition(
                    keyboardState.virtualCursor.rank,
                    maxFile + 0.5,
                    draggedIcon,
                    icons,
                    layout,
                    isFolder,
                    currentScreen
                );
                
                const targetFile = isAppendValid ? maxFile + 0.5 : maxFile;
                cursor.showVirtualCursor(keyboardState.virtualCursor.rank, targetFile);
                updateDragIndicators(keyboardState.virtualCursor.rank, targetFile);
            }, 350);
        } else if (currentScreen > 0) {
            if (isFolder) {
                nav.goToFolderScreen(state.currentFolderScreen - 1);
            } else {
                nav.goToScreen(state.currentScreen - 1);
            }
            
            setTimeout(() => {
                hideScrollZoneHover();
                const layout = helpers.getLayout();
                
                if (inMoveMode) {
                    // In move mode, go to last available position (could be MAX+0.5 or MAX)
                    const maxFile = layout.leaves * 4 - 1;
                    const icons = helpers.getCurrentIcons();
                    const draggedIcon = keyboardState.moveMode.draggedIcon;
                    const currentScreen = helpers.getCurrentScreenForRegions();
                    
                    // Check if MAX+0.5 is valid
                    const isAppendValid = navLogic.isValidInsertPosition(
                        keyboardState.virtualCursor.rank,
                        maxFile + 0.5,
                        draggedIcon,
                        icons,
                        layout,
                        isFolder,
                        currentScreen
                    );
                    
                    const targetFile = isAppendValid ? maxFile + 0.5 : maxFile;
                    cursor.showVirtualCursor(keyboardState.virtualCursor.rank, targetFile);
                    updateDragIndicators(keyboardState.virtualCursor.rank, targetFile);
                } else {
                    // In normal mode, go to max occupied column
                    const icons = helpers.getCurrentIcons();
                    const maxFile = helpers.getMaxOccupiedFile(icons, layout, isFolder);
                    cursor.showVirtualCursor(keyboardState.virtualCursor.rank, maxFile >= 0 ? maxFile : 0);
                }
            }, 350);
        }
    } else if (keyboardState.scrollZoneHover === 'right') {
        const allIcons = isFolder ?
            window.icons.filter(icon => icon.kfolder === state.openFolder.id) :
            window.icons.filter(icon => icon.kfolder === 0);
        
        const layout = helpers.getLayout();
        const maxRegion = Math.max(...allIcons.map(icon => icon.region), -1);
        const regionsPerScreen = isFolder ? layout.leaves : layout.leaves * layout.bands;
        const maxScreen = Math.floor(maxRegion / regionsPerScreen);
        const currentScreen = helpers.getCurrentScreen();
        
        // Adjust maxScreen if there's a left temporary screen
        // The temporary is at index 0, so real screens are offset by +1
        const adjustedMaxScreen = (state.temporaryScreenSide === 'left') ? maxScreen + 1 : maxScreen;
        
        if (inMoveMode && currentScreen >= adjustedMaxScreen) {
            // Only create temporary screen if one doesn't already exist
            if (!state.temporaryScreenSide || state.temporaryScreenSide !== 'right') {
                if (isFolder) {
                    nav.createTemporaryFolderScreenToRight();
                } else {
                    nav.createTemporaryScreenToRight();
                }
            } else {
                // Temporary screen already exists, just navigate to it
                if (isFolder) {
                    const screensContainer = document.getElementById('folderScreens');
                    const newScreenIndex = screensContainer.children.length - 1;
                    nav.goToFolderScreen(newScreenIndex);
                } else {
                    const screensContainer = document.getElementById('appspaceScreens');
                    const newScreenIndex = screensContainer.children.length - 1;
                    nav.goToScreen(newScreenIndex);
                }
            }
            
            setTimeout(() => {
                hideScrollZoneHover();
                const layout = helpers.getLayout();
                const icons = helpers.getCurrentIcons();
                const draggedIcon = keyboardState.moveMode.draggedIcon;
                const currentScreen = helpers.getCurrentScreenForRegions();
                
                // Check if -0.5 is valid
                const isInsertBeforeValid = navLogic.isValidInsertPosition(
                    keyboardState.virtualCursor.rank,
                    -0.5,
                    draggedIcon,
                    icons,
                    layout,
                    isFolder,
                    currentScreen
                );
                
                const targetFile = isInsertBeforeValid ? -0.5 : 0;
                cursor.showVirtualCursor(keyboardState.virtualCursor.rank, targetFile);
                updateDragIndicators(keyboardState.virtualCursor.rank, targetFile);
            }, 350);
        } else if (currentScreen < adjustedMaxScreen) {
            if (isFolder) {
                nav.goToFolderScreen(state.currentFolderScreen + 1);
            } else {
                nav.goToScreen(state.currentScreen + 1);
            }
            
            setTimeout(() => {
                hideScrollZoneHover();
                
                if (inMoveMode) {
                    // In move mode, go to first available position (could be -0.5 or 0)
                    const layout = helpers.getLayout();
                    const icons = helpers.getCurrentIcons();
                    const draggedIcon = keyboardState.moveMode.draggedIcon;
                    const currentScreen = helpers.getCurrentScreenForRegions();
                    
                    // Check if -0.5 is valid
                    const isInsertBeforeValid = navLogic.isValidInsertPosition(
                        keyboardState.virtualCursor.rank,
                        -0.5,
                        draggedIcon,
                        icons,
                        layout,
                        isFolder,
                        currentScreen
                    );
                    
                    const targetFile = isInsertBeforeValid ? -0.5 : 0;
                    cursor.showVirtualCursor(keyboardState.virtualCursor.rank, targetFile);
                    updateDragIndicators(keyboardState.virtualCursor.rank, targetFile);
                } else {
                    // In normal mode, go to min occupied column
                    const layout = helpers.getLayout();
                    const icons = helpers.getCurrentIcons();
                    const minFile = helpers.getMinOccupiedFile(icons, layout, isFolder);
                    cursor.showVirtualCursor(keyboardState.virtualCursor.rank, minFile >= 0 ? minFile : 0);
                }
            }, 350);
        }
    }
}

export function initScrollZoneStyles() {
    const style = document.createElement('style');
    style.textContent = `
        .scroll-zone.keyboard-hover {
            pointer-events: all !important;
            opacity: 1 !important;
            background: rgba(74, 144, 226, 0.4) !important;
            z-index: 95 !important;
        }
        
        .scroll-zone {
            position: absolute;
            top: 0;
            bottom: 0;
            width: 50px;
            z-index: 90;
            pointer-events: none;
            opacity: 0;
            transition: opacity 0.3s;
        }
        
        .scroll-zone.left {
            left: 0;
        }
        
        .scroll-zone.right {
            right: 0;
        }
        
        .scroll-zone.active {
            pointer-events: all;
            opacity: 1;
            background: rgba(74, 144, 226, 0.2);
        }
    `;
    document.head.appendChild(style);
}
